import clsx from 'clsx'
import iconMap from './IconMapping'
import PropTypes from 'prop-types'

const Icon = ({
  dataTestId = 'icon',
  name,
  style,
  size,
  color = '#60636b',
  disabled = false,
  selected = false,
}) => {
  const iconClass = clsx('flex items-center justify-center w-fit', {
    '[&_svg]:w-4 [&_svg]:h-4': size === 'small',
    '[&_svg]:w-6 [&_svg]:h-6': size === 'medium',
    '[&_svg]:w-8 [&_svg]:h-8': size === 'large',
    '[&_svg_path]:fill-current': !selected && !disabled,
    '[&_svg_path]:fill-theme-50': selected,
    '[&_svg_path]:fill-grey-80': disabled,
  })

  const iconStyle = {
    color,
  }

  const IconComponent = iconMap[name]?.[style]

  if (!IconComponent) {
    return null
  }

  return (
    <div className={iconClass} style={iconStyle} data-testid={dataTestId}>
      <IconComponent />
    </div>
  )
}

Icon.propTypes = {
  dataTestId: PropTypes.string,
  name: PropTypes.string.isRequired,
  style: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
}

export default Icon
